import React from "react";
import { PlusIcon } from "lucide-react";
import { Accent, Container, SectionHeader } from "./ui";
import { faqs } from "../data/content";
export function FaqSection() {
  return <section className="bg-cream py-12 md:py-24" data-id="element-61" data-mp="1bksc5hdjyt77">
      <Container data-id="element-62" data-mp="1bm3hvmqk6b0y">
        <SectionHeader eyebrow="Before you choose" title={<>
              Your questions, <Accent data-id="element-64" data-mp="2496c42o7bzle">answered</Accent>
            </>} data-id="element-63" data-mp="1bmln38v77zl0" />
        <div className="mx-auto max-w-[820px] space-y-3" data-id="element-65" data-mp="249zllbejp378">
          {faqs.map(f => <details key={f.question} className="group rounded-xl border border-line bg-white px-5 open:shadow-[0_10px_30px_rgba(22,78,85,0.08)] sm:px-6" data-id="element-66" data-mp="28a9t4shzk1o7">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5 text-[17px] font-semibold text-ink" data-id="element-67" data-mp="1zgwpowmaphnv">
                {f.question}
                <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sage text-petrol" data-id="element-68" data-mp="2rz0m8ch4za1y">
                  <PlusIcon className="h-4 w-4 transition-transform duration-200 ease-out group-open:rotate-45" aria-hidden="true" data-id="element-69" data-mp="14vts7a2nbdea" />
                </span>
              </summary>
              <p className="pb-5 text-base text-muted" data-id="element-70" data-mp="1emy420x0yi4w">{f.answer}</p>
            </details>)}
        </div>
      </Container>
    </section>;
}